<template>
  <div class="size-settings-wrap">
    <b-form-radio-group
      v-model="element.settings.imagePosition"
      :options="positionSettingList"
      value-field="value"
      text-field="label"
      :buttons="true"
      :disabled="element.settings.disabled"
      @change="handleSizeChange"
    ></b-form-radio-group>
  </div>
</template>

<script>
export default {
  name: 'OptionImagePositionSettings',
  data() {
    return {
      positionSettingList: [
        { label: 'Links', value: 'left' },
        { label: 'Mitte', value: 'center' },
        { label: 'Rechts', value: 'right' },
      ],
    };
  },
  props: {
    element: Object,
    isUserHasAccess: Boolean,
  },
  methods: {
    handleSizeChange(selectValue) {
      if (selectValue === 'individuel' && !this.element.settings.customSize) {
        this.$set(this.element.settings, 'customSize', {
          width: 75,
          height: 75,
        });
      }
    },
  },
};
</script>

<style scoped>
.size-settings-wrap {
  padding: 12px 0;
  padding-left: 20px;
}
.size-settings-wrap ::v-deep .btn-group-toggle {
  display: flex;
  gap: 7px;
  align-items: center;
  justify-content: center;
  flex-flow: row;
}
.size-settings-wrap ::v-deep .btn {
  border-radius: 16px !important;
  height: 30px;
  min-width: 61px;
  border: 0.7px solid #d9dbdc;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  font-family: 'OpenSans-regular';
  font-size: 14px;
  letter-spacing: -0.02em;
  line-height: 30px;
  color: #000000;
  transition: transform 0.3s ease;
}
.size-settings-wrap ::v-deep .btn:hover {
  border-color: #000000;
  transition: 0.2s ease all;
}
.size-settings-wrap ::v-deep .btn.active {
  background-color: #060606;
  border-color: #060606;
  color: #ffffff;
}

.size-settings-wrap ::v-deep .btn input {
  display: none;
}
</style>
